import { jsx as I } from "react/jsx-runtime";
import { useState as c, useCallback as f, useEffect as l, useContext as S, createContext as g } from "react";
const w = 768, m = g(
  void 0
);
function E({
  children: o,
  defaultOpen: a = !0,
  persistenceKey: n
}) {
  const [b, v] = c(!1), [r, d] = c(() => {
    if (typeof window > "u") return a;
    if (n) {
      const e = localStorage.getItem(n);
      if (e !== null) return e === "true";
    }
    return a;
  }), i = f(
    (e) => {
      d(e), n && localStorage.setItem(n, String(e));
    },
    [n]
  ), s = f(() => {
    i(!r);
  }, [r, i]);
  return l(() => {
    const e = window.matchMedia(`(max-width: ${w - 1}px)`), t = () => {
      const u = window.innerWidth < w;
      v(u), u && d(!1);
    };
    return e.addEventListener("change", t), t(), () => e.removeEventListener("change", t);
  }, []), l(() => {
    const e = (t) => {
      (t.metaKey || t.ctrlKey) && t.key === "b" && (t.preventDefault(), s());
    };
    return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
  }, [s]), /* @__PURE__ */ I(
    m.Provider,
    {
      value: { isOpen: r, setIsOpen: i, toggleSidebar: s, isMobile: b },
      children: o
    }
  );
}
function C() {
  const o = S(m);
  if (o === void 0)
    throw new Error(
      "useInsetSidebar must be used within an InsetSidebarProvider"
    );
  return o;
}
export {
  E as InsetSidebarProvider,
  C as useInsetSidebar
};
